import React from "react";
import { Link } from "react-router-dom";
import { board } from "../data/team";
import "./Board.css";

export default function Board() {
  return (
    <main>
      <section className="page-hero" aria-label="Board page hero">
        <div
          className="page-hero-bg"
          style={{ backgroundImage: "url('/images/gallery/eating-children-05.jpg')" }}
        />
        <div className="container page-hero-content">
          <span className="eyebrow" style={{ color: "var(--amber-light)" }}>
            Governance
          </span>
          <h1>Board of Directors</h1>
          <p>
            Our Board provides strategic oversight, governance, and
            accountability to ensure the Foundation fulfils its mission with
            integrity.
          </p>
        </div>
      </section>

      <section
        className="section board-intro-section"
        aria-labelledby="board-intro-heading"
      >
        <div className="container">
          <div className="board-intro-grid">
            <div>
              <span className="eyebrow">Our Governance Model</span>
              <h2 id="board-intro-heading">Accountable Leadership</h2>
              <div className="divider" />
              <p>
                The Food and Nutrition Foundation Advisory Board of Directors holds
                ultimate responsibility for the organisation's strategic
                direction, financial accountability, and adherence to its
                founding mission. 
              </p>
              <p>
                All Board members serve in a voluntary capacity, contributing
                their expertise in finance, programme development, community
                relations, and strategic leadership.
              </p>
            </div>
            <div className="board-principles">
              {[
                {
                  label: "Transparency",
                  desc: "Full financial accountability to donors and the communities we serve.",
                },
                {
                  label: "Integrity",
                  desc: "Every decision is made in the best interest of the most vulnerable.",
                },
                {
                  label: "Impact",
                  desc: "Strategic focus on measurable, long-term community transformation.",
                },
              ].map((p, i) => (
                <div className="board-principle" key={i}>
                  <div className="board-principle-num">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div>
                    <strong>{p.label}</strong>
                    <p>{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        className="section board-members-section"
        aria-labelledby="board-members-heading"
      >
        <div className="container">
          <div className="section-title">
            <span className="eyebrow">The Board</span>
            <h2 id="board-members-heading">Board of Directors</h2>
            <div className="divider divider-center" />
          </div>
          <div className="board-grid">
            {board.map((member) => (
              <article
                className="board-card"
                key={member.id}
                aria-labelledby={`board-${member.id}`}
              >
                <div className="board-card-img">
                  <img src={member.image} alt={member.name} loading="lazy" />
                </div>
                <div className="board-card-body">
                  <h3 id={`board-${member.id}`}>{member.name}</h3>
                  <p className="board-card-title">{member.title}</p>
                  <p className="board-card-bio">{member.bio}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-band" aria-label="Support CTA">
        <div className="container cta-band-inner">
          <div>
            <h2>Trust the Foundation</h2>
            <p>
              We operate with full transparency. Your donation is in accountable
              hands.
            </p>
          </div>
          <div className="cta-band-actions">
            <Link to="/donate" className="btn btn-primary btn-lg">
              Donate Now
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Contact the Board
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
